// Tariff lookup with descriptions — loads official DGD data (16K+ entries)

let _tarif = null;

export async function loadTarif() {
  if (_tarif) return _tarif;
  try {
    const resp = await fetch('/tarif.json');
    _tarif = await resp.json();
  } catch { _tarif = {}; }
  return _tarif;
}

// Parse entry: "DD,TVA,FAP|description" or "DD,TVA,FAP"
function parseEntry(val) {
  const [ratesPart, desc] = val.split('|');
  const parts = ratesPart.split(',');
  return {
    dd: parseInt(parts[0]) || 0,
    tva: parseInt(parts[1]) || 19,
    fap: parts[2] ? parts[2].split(';').filter(Boolean) : [],
    description: desc || '',
  };
}

// Lookup: tries 10→8→6→4 digits
export function lookupTarif(code) {
  if (!_tarif || !code) return null;
  const clean = code.replace(/\./g, '');
  const keys = [
    `${clean.slice(0,4)}.${clean.slice(4,6)}.${clean.slice(6,8)}.${clean.slice(8,10)}`,
    `${clean.slice(0,4)}.${clean.slice(4,6)}.${clean.slice(6,8)}`,
    `${clean.slice(0,4)}.${clean.slice(4,6)}`,
    clean.slice(0,4),
  ];
  for (const k of keys) {
    if (_tarif[k]) return { matched_key: k, ...parseEntry(_tarif[k]) };
  }
  return null;
}

// Get all 10-digit codes under a 4 or 6-digit position with their descriptions
export function getSubPositions(positionPrefix) {
  if (!_tarif) return [];
  const prefix = positionPrefix.replace(/\./g, '');
  const results = [];
  for (const [key, val] of Object.entries(_tarif)) {
    // Only 10-digit codes (XXXX.XX.XX.XX = 13 chars with dots)
    if (key.length === 13 && key.replace(/\./g, '').startsWith(prefix)) {
      const parsed = parseEntry(val);
      if (parsed.description) {
        results.push({ code: key, description: parsed.description, dd: parsed.dd });
      }
    }
  }
  return results;
}
